/**
 * @fileoverview Agent definition for prose-shortener-v2.
 *
 * This agent shortens a chapter draft to roughly 75% of its original length
 * while maintaining the story's essential elements and narrative flow.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-shortener-v2',
  kind: 'primitive',
  name: 'Prose Shortener',
  description: 'Shortens a chapter draft to roughly 75% of its length while preserving essential narrative elements.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-prose-shortener-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'draft-refiner-v2',
      'prose-expander-v2',
      'selection-reviser-v2',
    ],
  },
};
